import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'
import { post } from '@rails/request.js'
import { formDataToObject } from '~/utils/forms'

const expectedParamsFromForm = [
  'direction',
  'end_year',
  'start_year',
  'unit',
  'value',
  'yearly',
  'report_indicator_id',
  'activity_datum_ids'
]

export default class extends Controller {
  static targets = ['turboFrameWrapper']

  static values = {
    params: Object,
    url: String
  }

  connect() {
    useIntersection(this, { eventPrefix: false })
  }

  appear() {
    this.element.dispatchEvent(new Event('input'))
  }

  preview(event) {
    // No need to request for a preview if the preview block is not visible
    if (!this.turboFrameWrapperTarget.checkVisibility()) {
      return
    }

    const form = event.target.closest('form')

    return post(this.urlValue, {
      body: { preview: this.#previewParams(form) },
      responseKind: 'turbo-stream'
    })
  }

  #extractFormValues(form) {
    const formData = new FormData(form)
    const formDataObj = formDataToObject(formData)

    return Object.fromEntries(
      Array.from(Object.entries(formDataObj))
        .map(([field, value]) => [field.replace(/.*\[([^[\]]+)](?:\[])?$/, '$1'), value])
        .filter(([param]) => expectedParamsFromForm.includes(param))
    )
  }

  #previewParams(form) {
    const formParams = this.#extractFormValues(form)

    return {
      turbo_frame_id: this.#turboFrameId,
      ...this.paramsValue,
      ...formParams
    }
  }

  /**
   * As the `<turbo-frame>` tag will be replaced after each preview, we can not use it as a target directly.
   */
  get #turboFrameId() {
    return this.turboFrameWrapperTarget.querySelector('turbo-frame').id
  }
}
